import React from "react";
import { CircularProgress, Grid } from "@mui/material";

const LoadingComponent = ({ loading_text }) => {
  return (
    <Grid
      container
      xs={12}
      justifyContent="center"
      alignItems="center"
      style={{ minHeight: "40vh" }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <CircularProgress size={50} />

        <p
          className="loading-text"
          style={{ margin: 0, textAlign: "center" }}
        >
          {loading_text}
        </p>
      </div>
    </Grid>
  );
};

export default LoadingComponent;